
<div class="mainview">
  <div class="lableForGraph">
    <strong>  Container process status data for <mark>last 24 hours (current hour rounded to next hour)</mark></strong>
    <button pButton class="theme-button" type="submit" label="Refresh" (click)="getProgressTrackerData()"></button>
  </div>
  <ngx-charts-bar-horizontal-stacked [view]="view" [scheme]="colorScheme" [results]="multi" [gradient]="gradient"
      [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend" [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" >
    </ngx-charts-bar-horizontal-stacked>
</div>
